export class Utils {
  static convertHoursToDays(hours: number): number {
    return hours / 8;
  }

  static convertDaysToHours(days: number): number {
    return Math.round(days * 8 * 100) / 100;
  }
}
